import Tooltip from '@mui/material/Tooltip';
import * as MuiIcons from '@mui/icons-material';

export interface IconsProps {
    addTooltip?: string;
    iconName: string;
    iconClicked?: () => void;
    fontSize?: number;
    color?: string
}

const Icons = ({ addTooltip, iconName, iconClicked, fontSize = 20, color }: IconsProps) => {
    const IconComponent = MuiIcons[iconName as keyof typeof MuiIcons];
    
    if (!IconComponent) {
        console.warn(`Icone "${iconName}" não encontrado`);
        return null;
    }
    
    return (
        <Tooltip title={addTooltip}>
            <IconComponent onClick={iconClicked} sx={{ fontSize, color }} style={{ cursor: 'pointer' }}/>
        </Tooltip>
    )
}

export default Icons;